import validate from "/home/node/app/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("/home/node/app/middleware/auth.js")
}